module.exports = __webpack_public_path__ + "static/img/6.e7a0292.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/eng/6.png
// module id = rZCX
// module chunks = 0